import { CommonUtil } from "@/utils/common.util";
import httpClient from "../../config/httpClient";
import { CreatedIdDto, GenericSearchResDto, UpdateProcessFileDto } from "../../models/common.model";
import { SaleProcessDto } from "../../models/saleProcess.model";
import {
	CreateSaleProcessApprovalDataDto,
	CreateSaleProcessApprovalDto,
	CreateSaleProcessApprovalResDto,
	CreateSaleProcessDto,
	CreateSaleProcessFileDto,
	SaleProcessFileDto
} from "../model";

export abstract class MainSaleProcessService {
	private static readonly BASE_URL = "/sys03/main-sale-processes";

	public static sendToBss(id: string) {
		const url = `${this.BASE_URL}/${id}/send`;
		return httpClient.put(url);
	}

	public static sendToDigitel(id: string) {
		const url = `${this.BASE_URL}/${id}/send/digitel`;
		return httpClient.put(url);
	}

	public static create(payload: CreateSaleProcessDto) {
		return httpClient.post<CreatedIdDto>(this.BASE_URL, payload).then((response) => response.data);
	}

	public static checkByPhone(phone: string) {
		const url = `${this.BASE_URL}/check-by-phone/${phone}`;
		return httpClient.get<void>(url);
	}

	public static fetchById(id: number) {
		const url = `${this.BASE_URL}/${id}`;
		return httpClient.get<SaleProcessDto>(url).then((response) => response.data);
	}

	public static patch<T>({ id, payload }: { id: number; payload: T }) {
		const url = `${this.BASE_URL}/${id}`;
		return httpClient.patch<void>(url, payload).then((response) => response.data);
	}

	public static fetchFiles(id: number) {
		const url = `${this.BASE_URL}/${id}/files`;
		return httpClient
			.get<GenericSearchResDto<SaleProcessFileDto>>(url, {
				params: {
					page: 1,
					limit: -1
				}
			})
			.then((response) => response.data);
	}

	public static downloadFile(id: number) {
		const url = `${this.BASE_URL}/files/${id}/download`;
		return httpClient.get(url, { responseType: "blob" });
	}

	public static createFile({ saleProcessFile }: { saleProcessFile: CreateSaleProcessFileDto }) {
		const { saleProcessId, fileName, file, type, comment } = saleProcessFile;

		const formData = new FormData();
		formData.append("saleProcessId", String(saleProcessId));
		formData.append("fileName", fileName);
		formData.append("file", file);
		formData.append("type", type);
		if (comment) {
			formData.append("comment", comment);
		}
		const url = `${this.BASE_URL}/files`;
		return httpClient.post(url, formData, {
			headers: {
				"Content-Type": "multipart/form-data"
			}
		});
	}

	public static updateFile({ id, saleProcessFile }: { id: number; saleProcessFile: UpdateProcessFileDto }) {
		const url = `${this.BASE_URL}/files/${id}`;
		const payload = CommonUtil.clearObjectEmptyStrings({ obj: saleProcessFile });

		return httpClient.put(url, payload);
	}

	public static deleteFile({ id }: { id: number }) {
		const url = `${this.BASE_URL}/files/${id}`;
		return httpClient.delete(url);
	}

	public static createApproval({ id, approval }: { id: number; approval: CreateSaleProcessApprovalDataDto }) {
		const url = `${this.BASE_URL}/${id}/approvals`;

		const body: CreateSaleProcessApprovalDto = {
			data: [approval]
		};
		return httpClient.post<CreateSaleProcessApprovalResDto>(url, body).then((response) => response.data);
	}
}
